module.exports = __webpack_public_path__ + "img/49.6f6d5290.png";